<template>
  <main v-bind="dKey('pageid', pageName, pageId)">
    <section class="prev-page-section" style="background-image:url(/static-assets/img/career-img.jpg);">
      <div class="container">
        <div v-bind="dKey('carUpTitle')" class="grey-title-block resp-number">{{info.carUpTitle}}</div>
      </div>
    </section>
    <section class="career-form-section">
      <div class="container">
        <span v-bind="dKey('carFormUpTitle')" class="section-title">{{info.carFormUpTitle}}</span>
        <h3 v-bind="dKey('carFormTitle')">{{info.carFormTitle}}</h3>
        <div class="career-form-wrapper">
          <form action="/" @submit="formSubmit">
            <div class="row inputs-wrapper">
              <div class="col-md-6 col-xl-4">
                <div v-bind:class="{'invalid-data': errors.fullname || $root.isAdmin()}">
                  <input name="fullname" type="text" v-bind="dKey('carFormFIO')" v-model="fullname" v-bind:placeholder="info.carFormFIO">
                  <div v-bind="dKey('carFormErrorName')" class="error-message">{{info.carFormErrorName}}</div>
                </div>
              </div>
              <div class="col-md-6 col-xl-4">
                <div v-bind:class="{'invalid-data': errors.position || $root.isAdmin()}">
                  <input name="position" type="text" v-bind="dKey('carFormD')" v-model="position" v-bind:placeholder="info.carFormD">
                  <div v-bind="dKey('carFormErrorPosition')" class="error-message">{{info.carFormErrorPosition}}</div>
                </div>
              </div>
              <div class="col-md-6 col-xl-4">
                <div v-bind:class="{'invalid-data': errors.country || $root.isAdmin()}">
                  <input name="country" type="text" v-bind="dKey('carFormCountry')" v-model="country" v-bind:placeholder="info.carFormCountry">
                  <div v-bind="dKey('carFormErrorCountry')" class="error-message">{{info.carFormErrorCountry}}</div>
                </div>
              </div>
              <div class="col-md-6 col-xl-4">
                <div v-bind:class="{'invalid-data': errors.language || $root.isAdmin()}">
                  <input name="language" type="text" v-bind="dKey('carFormLanguage')" v-model="language" v-bind:placeholder="info.carFormLanguage">
                  <div v-bind="dKey('carFormErrorLanguage')" class="error-message">{{info.carFormErrorLanguage}}</div>
                </div>
              </div>
              <div class="col-md-6 col-xl-4">
                <div v-bind:class="{'invalid-data': errors.email || $root.isAdmin()}">
                  <input name="email" type="email" v-bind="dKey('carFormEmail')" v-model="email" v-bind:placeholder="info.carFormEmail" value="">
                  <div v-bind="dKey('carFormErrorEmail')" class="error-message">{{info.carFormErrorEmail}}</div>
                </div>
              </div>
              <div class="col-md-6 col-xl-4">
                <div v-bind:class="{'invalid-data': errors.telephone || $root.isAdmin()}">
                  <input name="telephone" type="tel" v-bind="dKey('carFormTel')" v-model="telephone" v-bind:placeholder="info.carFormTel">
                  <div v-bind="dKey('carFormErrorTelephone')" class="error-message">{{info.carFormErrorTelephone}}</div>
                </div>
              </div>
            </div>
            <div v-show="success" v-bind="dKey('successSubmit')" v-bind:class="{'show' : success}" class="col-12 alert alert-success left fade" role="alert">{{info.successSubmit}}</div>
            <div class="send-btns">
              <div class="submit-btn">
                <input type="submit" v-bind="dKey('carFormLink')" v-bind:value="info.carFormLink">
              </div>
              <div v-bind:class="{'invalid-data': errors.file || $root.isAdmin()}" class="file-btn">
                <input name="file" @change="fileSelect" type="file" id="file-send" hidden>
                <label v-bind="dKey('carFromFile')" for="file-send">{{info.carFromFile}}</label>
                <input type="text" id="filename" class="filename" disabled>
                <div v-bind="dKey('carFormErrorFile')" class="error-message">{{errors.file}}</div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>
    <section id="anchor-sect" class="jobs-list-section">
      <div class="container">
        <span v-bind="dKey('carVacUpTitle')" class="section-title">{{info.carVacUpTitle}}</span>
        <h3 v-bind="dKey('carVacTitle')">{{info.carVacTitle}}</h3>
        <div class="jobs-list-wrapper">
          <div v-if="jobs" v-for="(job, index) in jobs" class="job-item">
            <div class="job-title">
              <p v-bind="dKey('jobs#' + index + '#title')" class="m-0">{{job.title}}</p>
              <button v-if="$root.isAdmin()" @click="removeVacancy(index)" class="btn remove-vacancy">remove</button>
            </div>
            <div class="job-text">
              <p v-bind="dKey('jobs#' + index + '#text')" v-html="job.text"></p>
              <ul v-bind="dKey('jobs#' + index + '#list')" v-html="job.list" class="m-0"></ul>
            </div>
          </div>
        </div>
        <div v-if="$root.isAdmin()" class="submit-btn new-vacancy"><input @click="addVacancy" type="submit" value="добавить"></div>
      </div>
    </section>
    <section class="vacancies-section hr-section">
      <div class="container position-relative">
        <span v-bind="dKey('carHrUpTitle')" class="section-title">{{info.carHrUpTitle}}</span>
        <h3 v-bind="dKey('carHrTitle')">{{info.carHrTitle}}</h3>
        <div class="row about-job-there">
          <div class="col-12 col-xl-6 job-description">
            <div class="hr-contact-wrapper">
              <div class="hr-contact-info">
                <a class="hr-email" v-bind="dKey('carHrEmail')" v-bind:href="'mailto:' + info.carHrEmail">{{info.carHrEmail}}</a>
                <!-- <a v-bind="dKey('carHrTel')" class="hr-tel" v-bind:href="'tel:' + info.carHrTel">{{info.carHrTel}}</a> -->
              </div>
            </div>
          </div>
          <div class="col-12 col-xl-5 workers-think ml-auto">
            <div class="worker-description">
              <p v-bind="dKey('carHrUpInfo')">{{info.carHrUpInfo}}</p>
              <span v-bind="dKey('carHrUpInfoName')" class="worker-name">{{info.carHrUpInfoName}}</span>
              <span v-bind="dKey('carHrUpInfoWho')" class="worker-position">{{info.carHrUpInfoWho}}</span>
            </div>
          </div>
        </div>
        <div v-bind="dKey('carHrDownTitle')" class="grey-title-block resp-number">{{info.carHrDownTitle}}</div>
      </div>
      <div class="worker-photo">
        <img src="/static-assets/img/hr-img.png" alt="">
      </div>
    </section>
  </main>
</template>

<script>

import {HTTP} from '../http-common'

export default {
  name: 'Vacancy',

  data() {
    return {
      info: {},
      jobs: null,
      pageId: 0,
      fullname: '',
      position: '',
      country: '',
      language: '',
      email: '',
      telephone: '',
      file: '',
      success: false,
      pageName: 'vacancy',
      errors: {}
    }
  },

  mounted() {
    $('.jobs-list-wrapper').on('click', '.job-title', function(){
      // if ($(this).siblings('.job-text').css('display') == 'none'){
      //   $('.job-title').removeClass('job-detail');
      //   $('.job-text').slideUp();
      //   $(this).addClass('job-detail');
      //   $(this).siblings('.job-text').slideDown();}
      // else if ($(this).siblings('.job-text').css('display') == 'block'){
      //   $('.job-title').removeClass('job-detail');
      //   $('.job-text').slideUp();
      // }
    })

    $('.file-btn input[type=file]').change(function(){
      var filename = $(this).val().replace(/.*\\/, '');

      $('#filename').val(filename);
    })

    document.querySelectorAll('[data-key]').forEach(function(node){
      node.contentEditable = true
    })
  },

  created() {
    this.getPage()
  },

  watch:{
    $route (to, from) {
      this.getPage()
    },

    'jobs': function() {
      setTimeout(function(){
        document.querySelectorAll('[data-key]').forEach(function(node){
          node.contentEditable = true
        })
      }, 1000)
    }
  },

  methods: {
    dKey(key, page, pageId) {
      return this.$root.dKey(key, page, pageId)
    },

    getPage() {
      this.$root.getPage('vacancy', this.$root.language_id, response => {
        this.info = response.info
        this.pageId = response.pageId

        // Models
        if (this.$root.isAdmin()) {
          this.fullname = this.info.carFormFIO
          this.position = this.info.carFormD
          this.country = this.info.carFormCountry
          this.language = this.info.carFormLanguage
          this.email = this.info.carFormEmail
          this.telephone = this.info.carFormTel
          this.file = this.info.carFormFIO
          this.success = true
        }

        this.jobs = this.info.jobs || []
      })
    },

    fileSelect(event) {
      this.file = event.target.files
    },

    formSubmit(event) {
      event.preventDefault()

      let self = this

      $.ajax({
          url: '/static-assets/job.php',
          type: 'POST',
          data: new FormData(event.target),
          processData: false,
          contentType: false
      }).done(function(res){
        if (res.success) {
          self.fullname =
          self.position =
          self.country =
          self.language =
          self.email =
          self.telephone =
          self.file = ''

          self.success = true;

          setTimeout(function(){
            self.success = false
          }, 5000)
        } else {
          self.errors = res.errors
        }
      });
    },

    addVacancy() {
      let jobs = this.jobs || []

      this.jobs = null

      jobs.push({
        title: 'Заголовок',
        text: 'Текст описания вакансии',
        list: '<li>Элемент списка 1;</li><li>Элемент списка 2;</li><li>Элемент списка 3;</li><li>Элемент списка 4.</li>'
      })

      this.jobs = jobs
    },

    removeVacancy(remove) {
      let jobs = this.jobs || []

      this.jobs = null
      this.jobs = jobs.filter((item, index) => {return index != remove})
    }
  }
}

</script>

<style scoped>
  .new-vacancy input {
    background: #f4f4f4;
  }

  .new-vacancy input:hover {
    background: transparent;
  }

  .remove-vacancy {
    position: absolute;
    right: -100px;
    top: 50%;
    transform: translate(0, -50%);
  }
</style>
